<template>
  <div class="row">
    <div class="col-md-6">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('string.applicantCancelled') }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <div class="row">
            <div
              class="col-xs-12"
              v-if="borrowAmount && borrowAmount"
            >
              <cash-hero-table-with-chart
                :title-primary="$t('string.amountApplicantCancelled')"
                :current-amount="borrowCurrentAmount"
                :previous-amount="borrowPreviousAmount"
                :current-total="borrowCurrentTotal"
                :previous-total="borrowPreviousTotal"
                :title-secondary="$t('string.totalApplicantCancelled')"
              />
            </div>
            <div class="col-xs-12">
              <highcharts :options="borrowChartOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('string.loanCancelled') }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <div class="row">
            <div
              class="col-xs-12"
              v-if="loanAmount && loanTotal"
            >
              <cash-hero-table-with-chart
                :title-primary="$t('string.amountLoanCancelled')"
                :current-amount="loanCurrentAmount"
                :previous-amount="loanPreviousAmount"
                :current-total="loanCurrentTotal"
                :previous-total="loanPreviousTotal"
                :title-secondary="$t('string.totalLoanCancelled')"
              />
            </div>
            <div class="col-xs-12">
              <highcharts :options="loanChartOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CashHeroBoxToolsAction from '../../../components/CashHeroBoxToolsAction'
import CashHeroTableWithChart from '@/views/dashboard/charts/CashHeroTableWithChart'

export default {
  name: 'ApplicantLoanCancelBoxChart',
  components: {
    CashHeroTableWithChart,
    CashHeroBoxToolsAction
  },
  data () {
    return {
      borrowAmount: null,
      borrowTotal: null,
      borrowCurrentAmount: 0,
      borrowCurrentTotal: 0,
      borrowPreviousAmount: 0,
      borrowPreviousTotal: 0,
      borrowChartOptions: {
        width: '100%',

        title: {
          text: this.title
        },
        xAxis: [
          {
            categories: []
          }
        ],
        yAxis: [
          {
            gridLineWidth: 1,
            labels: {
              format: '{value} $',
              style: {
                color: 'black'
              }
            },
            title: {
              text: 'Dollar of applicants',
              style: {
                color: 'black'
              }
            },
            opposite: true
          },
          {
            gridLineWidth: 0,
            title: {
              text: 'Applicant',
              style: {
                color: 'black'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: 'black'
              }
            },
            opposite: false
          }
        ],
        tooltip: {
          shared: true
        },
        colors: ['blue', 'gold'],
        series: [
          {
            name: 'Applicant',
            type: 'spline',
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: ' Applicants'
            }
          },
          {
            name: 'Dollar of applicants',
            type: 'spline',
            data: [],
            tooltip: {
              valueSuffix: ' $'
            }
          }
        ]
      },
      loanAmount: null,
      loanTotal: null,
      loanCurrentAmount: 0,
      loanCurrentTotal: 0,
      loanPreviousAmount: 0,
      loanPreviousTotal: 0,
      loanChartOptions: {
        width: '100%',

        title: {
          text: this.title
        },
        xAxis: [
          {
            categories: []
          }
        ],
        yAxis: [
          {
            gridLineWidth: 1,
            labels: {
              format: '{value} $',
              style: {
                color: 'black'
              }
            },
            title: {
              text: 'Dollar of loans',
              style: {
                color: 'black'
              }
            },
            opposite: true
          },
          {
            gridLineWidth: 0,
            title: {
              text: 'Loans',
              style: {
                color: 'black'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: 'black'
              }
            },
            opposite: false
          }
        ],
        tooltip: {
          shared: true
        },
        colors: ['blue', 'gold'],
        series: [
          {
            name: 'Loans',
            type: 'spline',
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: ' Loans'
            }
          },
          {
            name: 'Dollar of Loans',
            type: 'spline',
            data: [],
            tooltip: {
              valueSuffix: ' $'
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      type: state => state.dashboard.buttonGroupActive,
      daterange: state => state.dashboard.daterange
    })
  },
  watch: {
    '$i18n.locale' () {
      if (this.chartOptions && this.chartOptions.title && this.chartOptions.title.text) {
        this.chartOptions.title.text = this.title
      }
    },
    type () {
      this.getApplicantChart()
    },
    daterange () {
      this.getApplicantChart()
    }
  },
  methods: {
    getApplicantChart () {
      let params = {}
      if (this.daterange && this.daterange[0] !== null && this.daterange[1] !== null) {
        params = {
          type: 'daterange',
          start_date: this.$moment(this.daterange[0]).locale('en').format('YYYY-MM-DD'),
          end_date: this.$moment(this.daterange[1]).locale('en').format('YYYY-MM-DD')
        }
      } else {
        params = {
          type: this.type.value.toUpperCase()
        }
      }

      this.$axios.post(process.env.VUE_APP_API + '/api/v1/report/dashboard/get-data-cancelled', params)
        .then((response) => {
          if (response.data && response.data.data) {
            const data = response.data.data
            const borrow = data.borrow
            const loan = data.loan
            // borrow
            this.borrowChartOptions.series = borrow.series
            this.borrowChartOptions.xAxis[0].categories = borrow.categories

            const series = borrow.series
            this.borrowTotal = series[0].data
            this.borrowAmount = series[1].data

            if (Array.isArray(this.borrowAmount) && this.borrowAmount.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.borrowPreviousAmount = 0
                this.borrowCurrentAmount = this.borrowAmount.reduce((total, item) => total + item, 0)
              } else {
                this.borrowPreviousAmount = this.borrowAmount[this.borrowAmount.length - 2]
                this.borrowCurrentAmount = this.borrowAmount[this.borrowAmount.length - 1]
              }
            } else {
              this.borrowCurrentAmount = this.borrowAmount[0]
              this.borrowPreviousAmount = 0
            }

            if (Array.isArray(this.borrowTotal) && this.borrowTotal.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.borrowPreviousTotal = 0
                this.borrowCurrentTotal = this.borrowTotal.reduce((total, item) => total + item, 0)
              } else {
                this.borrowPreviousTotal = this.borrowTotal[this.borrowTotal.length - 2]
                this.borrowCurrentTotal = this.borrowTotal[this.borrowTotal.length - 1]
              }
            } else {
              this.borrowCurrentTotal = this.borrowTotal[0]
              this.borrowPreviousTotal = 0
            }

            // loan
            this.loanChartOptions.series = loan.series
            this.loanChartOptions.xAxis[0].categories = loan.categories

            const loanSeries = loan.series
            this.loanTotal = loanSeries[0].data
            this.loanAmount = loanSeries[1].data

            if (Array.isArray(this.loanAmount) && this.loanAmount.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.loanPreviousAmount = 0
                this.loanCurrentAmount = this.loanAmount.reduce((total, item) => total + item, 0)
              } else {
                this.loanPreviousAmount = this.loanAmount[this.loanAmount.length - 2]
                this.loanCurrentAmount = this.loanAmount[this.loanAmount.length - 1]
              }
            } else {
              this.loanCurrentAmount = this.loanAmount[0]
              this.loanPreviousAmount = 0
            }

            if (Array.isArray(this.loanTotal) && this.loanTotal.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.loanPreviousTotal = 0
                this.loanCurrentTotal = this.loanTotal.reduce((total, item) => total + item, 0)
              } else {
                this.loanPreviousTotal = this.loanTotal[this.loanTotal.length - 2]
                this.loanCurrentTotal = this.loanTotal[this.loanTotal.length - 1]
              }
            } else {
              this.loanCurrentTotal = this.loanTotal[0]
              this.loanPreviousTotal = 0
            }
          }
        })
    }
  },
  mounted () {
    if (this.type) {
      this.getApplicantChart()
    }
  }
}
</script>

<style scoped>

</style>
